import { Injectable } from '@angular/core';

import { BaseHttpClientService } from '../../base-http-client.service';


@Injectable({
  providedIn: 'root'
})
export class SendVideoReportService {
  constructor(private baseClient: BaseHttpClientService) { }

  call(data) {
    const res = this.baseClient.postWithAuth(
      `/api/v1/VideoErrorReport`,
      data
    );

    return res;
  }
}
